import Policy, { PATH as POLICY } from './Policy'

export default { Policy }
export const PATH = { POLICY }
